export default __webpack_public_path__ + "static/en-1-b8cf9584506a390e3605ce6053e84642.svg";